import React from 'react'
import styled from 'styled-components'
import { BrowserRouter as Router, Route, Link } from 'react-router-dom'

import banner from './banner.jpg'

import Post from '../Post'
import GridItem from '../GridItem'

function Channel() {
  return (
    <Router>
      <Container>
        <Banner>
          <img src={banner} width={'100%'} height={'100%'} alt="" />
        </Banner>

        <ChannelContent>
          <Route path="/channel" exact={true}>
            <List>
              <Post>Post 1</Post>
              <Post>Post 2</Post>
              <Post>Post 3</Post>
              <Post>Post 4</Post>
              <Post>Post 5</Post>
            </List>
          </Route>

          <Route path="/channel/grid" exact={true}>
            <Grid>
              <GridItem>Grid</GridItem>
              <GridItem>Grid</GridItem>
              <GridItem>Grid</GridItem>
              <GridItem>Grid</GridItem>
              <GridItem>Grid</GridItem>
              <GridItem>Grid</GridItem>
              <GridItem>Grid</GridItem>
              <GridItem>Grid</GridItem>
              <GridItem>Grid</GridItem>
              <GridItem>Grid</GridItem>
              <GridItem>Grid</GridItem>
              <GridItem>Grid</GridItem>
              <GridItem>Grid</GridItem>
            </Grid>
          </Route>

          <ChannelSidebar>
            <p>Channel description and so on</p>
            <ul>
              <li>
                <Link to="/channel">List</Link>
              </li>
              <li>
                <Link to="/channel/grid">grid</Link>
              </li>
            </ul>
          </ChannelSidebar>
        </ChannelContent>
      </Container>
    </Router>
  )
}

export default Channel

const List = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 20px;
`

const Grid = styled.div`
  width: auto;
  display: flex;
  flex-wrap: wrap;
`

const ChannelContent = styled.div`
  display: flex;
  height: 100%;
`

const ChannelSidebar = styled.div`
  width: 300px;
  flex-shrink: 0;
  border-left: 1px solid #404e53;

  @media only screen and (max-width: 600px) {
    display: none;
  }
`

const Container = styled.div`
  // display: flex;
  // flex-direction: column;
  width: 100%;
  // background: yellow;
`

const Banner = styled.div`
  display: flex;
  width: 100%;

  @media screen and (min-width: 2560px) {
    height: calc((2560px - 350px) * 0.2);
  }

  height: calc((100vw - 350px) * 0.2);
`
